export const labels = {
	bringToFront: {
		label: "Label.MobileCreator.Zone.Depth.Forward",
		default: "Forward",
	},
	sendToBack: {
		label: "Label.MobileCreator.Zone.Depth.Backward",
		default: "Backward",
	},
};
